module.exports = (__webpack_require__(35))(651);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/@ant-design/icons/lib/dist.js from dll-reference vendor_49736c16ac25d2e17270
// module id = 6639
// module chunks = 0